module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "product-categories"
    }
  }, [(!_vm.showr) ? _c('div', {
    staticClass: "col-md-3",
    attrs: {
      "id": "product-filters"
    }
  }, [_c('h1', [_vm._v("Our Products")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "capitalize category active-category",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.category('', $event)
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.filters.category), function(c) {
    return _c('li', [_c('a', {
      staticClass: "capitalize category",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.category(_vm.filterId(c), $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.filterName(c)))])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "products"
    }
  }, [(_vm.showr) ? _c('h1', [_vm._v("Our Products")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "product-search"
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "text",
      "name": "maxprice",
      "placeholder": "Enter max price"
    },
    on: {
      "change": _vm.maxprice,
      "keyup": _vm.maxprice
    }
  }), _vm._v(" "), (_vm.showr) ? _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('category', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Category")]), _vm._v(" "), _vm._l((_vm.filters.category), function(category) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(category)
      }
    }, [_vm._v(_vm._s(_vm.filterName(category)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('select', {
    attrs: {
      "name": "materials"
    },
    on: {
      "change": function($event) {
        _vm.advFilters('materials', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Material")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.filters.materials), function(material) {
    return _c('option', {
      staticClass: "capitalize",
      domProps: {
        "value": _vm.filterId(material)
      }
    }, [_vm._v(_vm._s(_vm.filterName(material)))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-j",
    class: {
      showadvs: _vm.showadvs
    },
    on: {
      "click": _vm.advs
    }
  }, [_vm._v("Advanced Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showadvs) ? _c('div', {
    attrs: {
      "id": "advanced-product-search"
    }
  }, [_c('div', [_c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('design', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Design")]), _vm._v(" "), _vm._l((_vm.filters.design), function(design) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(design)
      }
    }, [_vm._v(_vm._s(_vm.filterName(design)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('finish', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Finish")]), _vm._v(" "), _vm._l((_vm.filters.finish), function(finish) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(finish)
      }
    }, [_vm._v(_vm._s(_vm.filterName(finish)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('socket', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Socket Type")]), _vm._v(" "), _vm._l((_vm.filters.sockettype), function(sockettype) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(sockettype)
      }
    }, [_vm._v(_vm._s(_vm.filterName(sockettype)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('forplace', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Place")]), _vm._v(" "), _vm._l((_vm.filters.place), function(place) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(place)
      }
    }, [_vm._v(_vm._s(_vm.filterName(place)))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.code,
      staticClass: "product col-sm-6 col-md-4",
      attrs: {
        "to": '/products/product/' + product.code,
        "id": product.code
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": 'static/images/products/' + product.code + '.jpg',
        "alt": product.name
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_vm._v("Php " + _vm._s(_vm.formatMoney(product.price)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(product.categoryName))]), _vm._v(" "), (!_vm.disabled) ? _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.addToCart(product, $event)
        }
      }
    }, [_vm._v("Add to Cart")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.products.length) ? _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "4em 0"
    }
  }, [_vm._v("No Results Found")]) : _vm._e()], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('notification', {
    attrs: {
      "nbm": _vm.nbm,
      "nbc": _vm.nbc
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13814854"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = 139
// module chunks = 0